import {
  BLACK,
  BORDER_COLOR_SHADE_2,
  CHARCOAL_GREY,
  DARK_GREY,
  PRIMARY_BLUE,
  GREY,
  ICON_ERROR,
  LIGHT_BLUE,
  LIGHT_GRAY_BACKGROUND,
  WHITE,
} from '~/Constants/Colors.constants';
import {
  FONT_SIZE_LARGE,
  FONT_SIZE_LARGISH,
  FONT_SIZE_MEDIUM,
  FONT_SIZE_SMALL,
  FONT_SIZE_XS,
  FONT_SIZE_X_LARGE,
} from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';

export const OpeningHoursSectionStyles = makeStyles((theme) => ({
  container: {
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      paddingBottom: 0,
      backgroundColor: WHITE,
    },
  },
  timePicker: {
    textAlign: 'center',
  },
  headerWrapper: {
    paddingBottom: theme.spacing(1),
  },
  headerTitle: {
    fontSize: FONT_SIZE_SMALL,
    color: CHARCOAL_GREY,
  },
  dayRow: {
    position: 'relative',
    alignSelf: 'stretch',
  },
  headerTitleCol: {
    position: 'relative',
  },
  mobileHeaderWrapper: {
    borderTop: `1px solid ${BORDER_COLOR_SHADE_2}`,
    borderBottom: `1px solid ${BORDER_COLOR_SHADE_2}`,
  },
  title: {
    fontWeight: 'bolder',
    fontSize: FONT_SIZE_LARGE,
    display: 'flex',
    alignItems: 'center',

    padding: 15,
  },
  hasBottomBorder: {
    borderBottom: 'solid 1px',
    borderColor: BORDER_COLOR_SHADE_2,
    minHeight: 51,
  },
  row: {
    minHeight: 51,
    alignItems: 'center',
  },
  itemRow: {
    textAlign: 'center',
  },
  rightAlignItem: {
    justifyContent: 'end',
    alignItems: 'center',
    display: 'flex',
  },
  iconWrapper: {
    width: 30,
    height: 30,
    display: 'flex',
    backgroundColor: LIGHT_BLUE,
    borderRadius: 30,
    marginRight: 15,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 16,
    '&>svg': {
      color: CHARCOAL_GREY,
      fontSize: FONT_SIZE_LARGISH,
    },
  },
  dayHeader: {
    marginRight: 15,
    width: 45,
  },
  addButton: {
    border: `1px solid ${PRIMARY_BLUE}`,
    width: 20,
    height: 20,
    color: PRIMARY_BLUE,
    borderRadius: '50%',
    '&>svg': {
      fontSize: FONT_SIZE_MEDIUM,
    },
  },
  addButtonText: {
    marginTop: theme.spacing(1),
    marginLeft: 9,
    '&>svg': {
      marginRight: 10,
      width: 28,
      height: 28,
      fontSize: FONT_SIZE_MEDIUM,
      border: `1px solid ${PRIMARY_BLUE}`,
      borderRadius: '50%',
    },
  },
  deleteButton: {
    width: 20,
    height: 20,
    color: ICON_ERROR,
    borderRadius: '50%',
    '&>svg': {
      fontSize: FONT_SIZE_X_LARGE,
    },
  },
  copyButton: {
    fontSize: 14,
    '&>svg': {
      marginTop: -3,
      fontSize: 16,
      marginRight: 10,
    },
  },
  separator: {
    fontSize: `${FONT_SIZE_XS}px!important`,
    color: CHARCOAL_GREY,
  },
  hasMarginHorizontal: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  dayLabel: {
    textTransform: 'capitalize',
  },
  inactive: {
    backgroundColor: LIGHT_GRAY_BACKGROUND,
  },
  closeLabel: {
    color: DARK_GREY,
    textAlign: 'center',
  },
  cellWithPadding: {
    padding: '11px 0 0 16px',
  },
  actionCol: {
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-around',
    },
  },
  hiddenLabel: {
    opacity: 0,
  },
  ChevronRight: {
    color: GREY,
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
  },
  timeButton: {
    color: BLACK,
    fontWeight: 400,
    marginRight: 5,
    paddingRight: 0,
  },
}));

export const LocationEditCustomOpeningHoursStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),

    '& .MuiFormControlLabel-root': {
      marginLeft: 0,
      alignItems: 'start',
    },

    '& .MuiFormControlLabel-label': {
      maxWidth: '525px',
    },
  },
  switcher: {
    marginRight: theme.spacing(2),
  },
}));
